import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { colors, borderRadius, fonts } from "../../tokens";
import * as controls from "../../tokens/controls";
import { jsx as ___EmotionJSX } from "@emotion/core";
var normal = controls.normal,
    hover = controls.hover,
    disabled = controls.disabled,
    focus = controls.focus,
    active = controls.active,
    invalid = controls.invalid,
    invalidHover = controls.invalidHover;
var inputStyles = {
  "&[type]": _objectSpread(_objectSpread({}, normal), {}, {
    color: colors.gray.inkHeadings,
    appearance: "none",
    boxSizing: "border-box",
    "::placeholder": {
      color: colors.gray.inkSubdued
    },
    "&:hover": hover,
    "&:disabled": disabled,
    "&:focus": active,
    "&.focus-visible:focus": focus,
    gridArea: "input",
    display: "block",
    height: 44,
    width: "100%",
    borderRadius: borderRadius.small,
    margin: 0,
    padding: 10
  })
};
var invalidInputStyles = {
  "&[type]": _objectSpread(_objectSpread({}, invalid), {}, {
    "&:hover:not(:focus)": invalidHover
  })
};
var inputWithSuffixStyles = {
  "&[type]": {
    display: "block",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }
};
var inputWithPrefixStyles = {
  "&[type]": {
    display: "block",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }
};
var smallInputStyles = {
  "&[type]": _objectSpread({
    height: 32
  }, fonts["body-2"])
};
var largeInputStyles = {
  "&[type]": _objectSpread({
    height: 48
  }, fonts["heading-2"])
};
export var Input = React.forwardRef(function (_ref, ref) {
  var _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? "" : _ref$errorMessage,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? "" : _ref$prefix,
      _ref$suffix = _ref.suffix,
      suffix = _ref$suffix === void 0 ? "" : _ref$suffix,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      id = _ref.id,
      name = _ref.name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$onEnterPress = _ref.onEnterPress,
      onEnterPress = _ref$onEnterPress === void 0 ? function () {} : _ref$onEnterPress,
      className = _ref.className;
  var isValid = !errorMessage;
  var styles = [inputStyles];
  var onKeyDown = React.useCallback(function (event) {
    if (event.key === "Enter" && isValid) {
      onEnterPress(event);
    }
  }, [isValid, onEnterPress]);
  if (!isValid) styles.push(invalidInputStyles);
  if (suffix) styles.push(inputWithSuffixStyles);
  if (prefix) styles.push(inputWithPrefixStyles);
  if (size === "small") styles.push(smallInputStyles);
  if (size === "large") styles.push(largeInputStyles);
  return ___EmotionJSX("input", {
    type: type,
    ref: ref,
    "data-lpignore": "true",
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    css: styles,
    value: value,
    placeholder: placeholder,
    id: id,
    name: name,
    disabled: disabled,
    autoFocus: autoFocus,
    className: className
  });
});